import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import Main from './Main';
import HeroCeo from './HeroCeo';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage'

const CeoMessage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <HeroCeo />
            <TeamSinglePage />

            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    );
};

export default CeoMessage;
